import React from 'react';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text, Tooltip } from '@wix/design-system';
import { WixSaleLogoBadge } from './wix-sale-logo-badge';
import s from '../../sass/badge.module.scss';
export function WixSaleBadge({ amount, size = 'big' }) {
    const { t } = useEssentials();
    return (React.createElement(Box, { className: s.badgeHeight },
        React.createElement(Tooltip, { placement: "right", inline: true, content: React.createElement(Box, { direction: "vertical", gap: "6px" },
                React.createElement(Text, { size: "small", weight: "bold", skin: "light" }, t('wix.november.sale.badge')),
                React.createElement(Text, { size: "small", weight: "thin", skin: "light" }, t('wix.november.sale.badge.tooltip', { amount }))), size: "medium" },
            React.createElement(Box, { marginTop: "1px" },
                React.createElement(WixSaleLogoBadge, { amount: amount, size: size })))));
}
//# sourceMappingURL=wix-sale-badge.js.map